import React, {useContext, useState} from 'react';
import styles from './integration_buttons_icons.module.less';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Chevron_down from '../../img/icons/16/chevron_down.svg';

type Integration_buttons_icons_item = {
  id: string;
  img: string;
  name: string;
  link?: string;
};

type t_integration_buttons_icons_props = {
  items: Integration_buttons_icons_item[];
  oculus?: boolean;
};

export const Integration_buttons_icons = (
  props: t_integration_buttons_icons_props
)=>{
  const {oculus, items} = props;
  const {theme} = useContext(Settings_context);
  const [show_all, set_show_all] = useState(false);
  const default_items_count = oculus ? 16 : 8;
  const displayed_items = show_all ? items :
      items.slice(0, default_items_count);
  return <div className={cn(oculus && styles.oculus,
    !oculus && styles.toolip)}>
    <div className={cn(styles.browsers,
      oculus && styles.oculus_browsers)}>
        {displayed_items.map(({id, img, name, link})=>
          link ? <a href={link} key={id} className={styles.browsers_item}>
            <img src={img} alt={name} />
            <span>{name}</span>
          </a> : <div key={id} className={styles.browsers_item}>
            <img src={img} alt={name} />
            <span>{name}</span>
          </div>
        )}
    </div>
    {items.length > default_items_count &&
      <button
        className={cn(theme.p16, theme.color_n700, styles.show_all,
          styles.font_button_xs)}
        onClick={()=>set_show_all(!show_all)}
      >
        {show_all ? 'Show less' : 'Show all'} {oculus && <Chevron_down />}
      </button>
      }
  </div>;
};
